module.exports = __webpack_public_path__ + "img/h-1.d6b5e19b.png";